"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../services");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _ProductCardFactory = _interopRequireDefault(require("./ProductCardFactory"));
var _useLocalTheme = _interopRequireDefault(require("../../hooks/useLocalTheme"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const ProductCardWrapper = (0, _styledComponents.default)('div')(props => (0, _styledComponents.css)`
    ${_r10SourceLibrary.Mixins.advancedSpacing('padding', [0, 2])}
    ${(props === null || props === void 0 ? void 0 : props.paddingStyle) && _r10SourceLibrary.Mixins.respondTo.md(_r10SourceLibrary.Mixins.advancedSpacing('padding', props === null || props === void 0 ? void 0 : props.paddingStyle))}

  margin-top: 20px;
    display: flex;
    flex-direction: column;
    height: 100%;
    & [class*='ContainerWithLabelstyle__LabelContainer'] {
      & p {
        font-size: ${props => props.isSmallFontSize && '10px'};
      }
    }
  `);
const ProductContainerStyle = (0, _styledComponents.default)('div')(props => {
  var _props$label, _props$label2, _props$label3;
  return (0, _styledComponents.css)`
    & [class*='ContainerWithLabelstyle__LabelContainer'] {
      background-color: ${props === null || props === void 0 ? void 0 : (_props$label = props.label) === null || _props$label === void 0 ? void 0 : _props$label.bgColor};
      & p {
        color: ${props === null || props === void 0 ? void 0 : (_props$label2 = props.label) === null || _props$label2 === void 0 ? void 0 : _props$label2.color};
        font-weight: ${props === null || props === void 0 ? void 0 : (_props$label3 = props.label) === null || _props$label3 === void 0 ? void 0 : _props$label3.fontWeight};
      }
    }
    & [class*='Interactionstyle__BlankInteraction']::after {
      border: ${props === null || props === void 0 ? void 0 : props.containerBorderStyle};
    }
    display: flex;
    flex-direction: column;
    height: 100%;
  `;
});
const ProductContainer = _ref => {
  let {
    showFullWidthType,
    selectedProduct,
    setSelectedProduct,
    onSelect,
    selectOptions,
    tier,
    index
  } = _ref;
  const containerWithLabelStyle = (0, _useLocalTheme.default)(`comparison.containerWithLabelStyle`, null);
  const hasElevation = (0, _useLocalTheme.default)(`hasElevation`, true);
  return /*#__PURE__*/_react.default.createElement(ProductContainerStyle, _extends({
    "data-test-id": `compare-tab-title-${index}`
  }, containerWithLabelStyle ? {
    ...containerWithLabelStyle
  } : {}), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.ContainerWithLabel, {
    label: _services.Services.locale.localeString(`Recommendation.${tier}`),
    paddingLevel: 2,
    appearance: "secondary",
    level: showFullWidthType ? 2 : 1,
    dataAttributes: {
      'data-test-id': `tab-title-${index}`
    },
    elevation: hasElevation
  }, /*#__PURE__*/_react.default.createElement(_ProductCardFactory.default, {
    selectedProduct: selectedProduct,
    setSelectedProduct: setSelectedProduct,
    onSelect: onSelect,
    selectOptions: selectOptions,
    index: index
  })));
};
const ComparisonProductSelectorItem = _ref2 => {
  let {
    selectedProduct,
    setSelectedProduct,
    onSelect,
    selectOptions,
    index = null
  } = _ref2;
  const {
    tier
  } = selectedProduct;
  const showComparisonProductTypeFullWidth = (0, _useLocalTheme.default)(`comparison.showComparisonProductTypeFullWidth`, false);
  const comparisonCardsPadding = (0, _useLocalTheme.default)(`comparison.comparisonCardsPadding`, [0, 7]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "md",
    andAbove: true
  }, /*#__PURE__*/_react.default.createElement(ProductCardWrapper, {
    paddingStyle: comparisonCardsPadding
  }, /*#__PURE__*/_react.default.createElement(ProductContainer, {
    setSelectedProduct: setSelectedProduct,
    onSelect: onSelect,
    selectOptions: selectOptions,
    tier: tier,
    selectedProduct: selectedProduct,
    index: index
  }))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.MatchMedia, {
    breakpoint: "sm"
  }, /*#__PURE__*/_react.default.createElement(ProductCardWrapper, showComparisonProductTypeFullWidth ? {
    isSmallFontSize: true
  } : {}, /*#__PURE__*/_react.default.createElement(ProductContainer, {
    setSelectedProduct: setSelectedProduct,
    onSelect: onSelect,
    selectOptions: selectOptions,
    tier: tier,
    selectedProduct: selectedProduct,
    showFullWidthType: showComparisonProductTypeFullWidth,
    index: index
  }))));
};
var _default = ComparisonProductSelectorItem;
exports.default = _default;